var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 40,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing Page - Option2",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7318,
    transform: "translate(-354 -640)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 11",
    filter: "url(#filter0_dddd_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: -23.2217,
    y: -8,
    width: 194.778,
    height: 56.2891,
    rx: 4.46739,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0656 8.28454C17.1206 6.62501 17.5754 4.18248 19.1652 2.57796C20.6414 1.08713 22.4384 0.360971 23.557 0.0290645C23.6555 -0.00178205 23.7601 -0.00819739 23.8616 0.0103718C23.9632 0.0289409 24.0587 0.071937 24.1399 0.135651C24.2211 0.199364 24.2856 0.281882 24.3278 0.376086C24.37 0.470289 24.3887 0.573349 24.3822 0.676373C24.3088 2.26439 23.8907 4.63358 22.8125 5.90252C21.7966 7.09812 20.1646 8.68247 17.7716 8.95019C17.6799 8.96011 17.5871 8.95003 17.4997 8.92066C17.4123 8.89129 17.3323 8.84332 17.2652 8.78005C17.1981 8.71679 17.1455 8.63973 17.111 8.55419C17.0766 8.46865 17.0611 8.37666 17.0656 8.28454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.1622 38.6402C22.312 39.0803 23.4727 39.524 24.5235 39.524C26.7734 39.524 33.3217 34.3346 33.5564 28.947C33.5585 28.8113 33.5226 28.6776 33.453 28.561C33.3834 28.4444 33.2827 28.3495 33.1622 28.2869C31.4972 27.3554 28.7759 25.0338 28.6824 21.6579C28.5723 17.7227 30.5473 14.598 32.0418 13.3053C32.3792 13.0137 32.4947 12.5003 32.194 12.1738C30.8333 10.6885 28.0974 8.64391 25.5999 8.69342C23.7845 8.73009 22.1469 9.40857 20.7405 9.98804C19.6641 10.4336 18.7233 10.8224 17.9422 10.8224C17.2032 10.8224 16.3156 10.4373 15.2961 9.9917C13.9245 9.3939 12.3144 8.69342 10.51 8.69342C7.16531 8.69525 0.556519 11.4679 0.556519 22.1732C0.556519 27.8505 6.41531 39.6744 11.3609 39.524C12.4281 39.524 13.5687 39.0839 14.702 38.6438C15.8169 38.2111 16.9226 37.782 17.9422 37.782C18.9269 37.782 20.0381 38.2092 21.1622 38.6402Z",
    fill: "white"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_0_1",
    x: -300,
    y: -19,
    width: 529.557,
    height: 270.289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 36
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 81
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_0_1",
    result: "effect3_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 145
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_0_1",
    result: "effect4_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7318,
    fill: "white",
    transform: "translate(-354 -640)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.11607749dec0eca43d23fa682caaaa45.svg";
export { ForwardRef as ReactComponent };